import { render, staticRenderFns } from "./IP.vue?vue&type=template&id=5ef6d70a&scoped=true&"
import script from "./IP.vue?vue&type=script&lang=js&"
export * from "./IP.vue?vue&type=script&lang=js&"
import style0 from "./IP.vue?vue&type=style&index=0&id=5ef6d70a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef6d70a",
  null
  
)

export default component.exports